import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass, NgIf } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleCheck, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from '@shared/components/notification/notification.service';

@Component({
  selector: 'app-notification',
  imports: [NgIf, NgClass, FontAwesomeModule],
  templateUrl: './notification.component.html',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('100ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class NotificationComponent {
  private notificationService = inject(NotificationService);

  errorIcon = faCircleExclamation;
  successIcon = faCircleCheck;
  notification = computed(() => this.notificationService.message());

  closeNotification() {
    this.notificationService.clearNotification();
  }
}
